<div class="container-md d-flex">
    <div class="col-12 text-end">
        <button type="button" aria-label="Close" (click)="activeModal.close(0)">
            <span class="closeButton" aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h4 class="text-uppercase">{{'IDS_ACCOUNT_NOT_ACTIVATED' | translate}}</h4>
    </div>
    <div class="d-flex justify-content-center my-3">
        <label>{{'IDS_CHECK_EMAIL' | translate}}</label>
    </div>
</div>